export default "__VITE_ASSET__Dk02Skmm__"